var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 5,
    viewBox: "0 0 22 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 88408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2567",
    d: "M2 2.64598C3.64693 2.48128 5.30017 2.18897 6.96245 2.05599C9.16106 1.8801 11.3629 1.7772 13.5637 1.643C15.2053 1.5429 16.8747 1.54388 18.5196 1.584C19.1581 1.59957 19.7591 1.81999 20.4076 1.81999",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinus);
export default __webpack_public_path__ + "static/media/icon-minus.ce9b8c585f517bc8169fc8a2341bc74e.svg";
export { ForwardRef as ReactComponent };